/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit No/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function No({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/PaymentPlans/Content/Content/PaymentPlan/Content/Content/Summary/Payors/Payor/Person/No"
  
}) {
let payorIsPrimaryValueData = fromData.useDataValue({ viewPath,
context: 'payor',
path: 'is_primary',
})
let dtColorsBlack = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.black'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 flexGrow={1}
 flexShrink={1}
 flexBasis={0}
 color={dtColorsBlack}
 text={payorIsPrimaryValueData ? "[Primary payor]" : "[Secondary payor]"}
 data="payor.is_primary"
/>
{children}
</React.Fragment>)
}